import React, { PureComponent } from 'react';
import { Icon, Row, Col, Input } from 'antd';
import { language } from '../../../language';
import { cloneDeep, get } from 'lodash';
import { LinkType, UploadPicture } from '../../tools';
import { LinkTypeMode } from '../../../types';

//导航项
export class NavItem extends PureComponent<{
    sourceRoot?: {
        image?: string;
    };
    items?: Array<any>;
    index?: number;
    onChange?: (value: any) => void;
    item?: any;
    uploadAction?: string;
    linkTypes?: Array<any>;
    linkTypeMode?: LinkTypeMode;
    showStyle: string;
    selector?: any;
}> {
    state = {
        uploadLoading: false,
    };
    change = (item) => {
        const { items, onChange, index } = this.props;
        let newItems = cloneDeep(items);
        newItems.splice(index, 1, item);
        onChange(newItems);
    };

    onNameChange = (event) => {
        const { item } = this.props;
        let newItem = cloneDeep(item);
        let newValue = { ...newItem, name: event.target.value };
        this.change(newValue);
    };

    removeItem = () => {
        const { items, onChange, index } = this.props;
        let newValue = cloneDeep(items);
        newValue.splice(index, 1);
        onChange(newValue);
    };

    onUpload = (path) => {
        const { item } = this.props;
        let newItem = cloneDeep(item);
        newItem.pic = path;
        this.change(newItem);
    };

    render() {
        const {
            item,
            linkTypes,
            linkTypeMode,
            showStyle,
            uploadAction,
            selector,
            sourceRoot,
        } = this.props;

        return (
            <Row className="entry-item">
                <Icon type="close" className="item-remove" title="移除" onClick={this.removeItem} />
                <Col className="entry-item-image" span={4}>
                    {showStyle === 'image' || showStyle === 'img' ? (
                        <UploadPicture
                            value={item.pic}
                            sourceRoot={sourceRoot}
                            onChange={this.onUpload}
                            uploadAction={uploadAction}
                        />
                    ) : null}
                </Col>
                <Col className="entry-item-content" span={19}>
                    {showStyle === 'text' || showStyle === 'image' ? (
                        <div className="link-item-field">
                            <label className="field-name">
                                {language.getText('components.Nav.name')}：{' '}
                            </label>
                            <Input
                                className="field-control"
                                value={get(item, 'name')}
                                onChange={this.onNameChange}
                                minLength={1}
                                maxLength={8}
                            />
                        </div>
                    ) : null}
                    <LinkType
                        linkTypes={linkTypes}
                        linkTypeMode={linkTypeMode}
                        value={item}
                        selector={selector}
                        onChange={(item) => {
                            this.change(item);
                        }}
                    />
                </Col>
            </Row>
        );
    }
}
